import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "rounded-xl border border-red-200 bg-red-50 p-4"
};
const _hoisted_2 = {
  class: "mt-1 text-sm text-red-700"
};
const _hoisted_3 = {
  class: "mt-3 flex justify-end"
};
const _hoisted_4 = ["disabled"];
import { computed } from 'vue';
import { buildContinueResume } from '../../composables/agentProtocol';
export default {
  __name: 'SuspendedCard',
  props: {
    snapshot: {
      type: Object,
      required: true
    },
    pending: {
      type: Boolean,
      default: false
    }
  },
  emits: ['resume'],
  setup(__props) {
    const continuePayload = computed(() => buildContinueResume().payload);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("p", {
        class: "text-sm font-semibold text-red-800"
      }, "任务已挂起", -1)), _createElementVNode("p", _hoisted_2, _toDisplayString(__props.snapshot.suspended_reason || '（无原因说明）'), 1), _cache[2] || (_cache[2] = _createElementVNode("p", {
        class: "mt-2 text-xs text-red-500"
      }, "请按上述原因处置（如调整限额、补录条件库），完成后恢复执行", -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
        class: "btn-primary form-control-sm",
        disabled: __props.pending,
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('resume', continuePayload.value))
      }, _toDisplayString(__props.pending ? '恢复中…' : '已处理，恢复执行'), 9, _hoisted_4)])]);
    };
  }
};